import {switchMap} from "rxjs/operators";
import {ofType} from "redux-observable";

import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

const setIdentification = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.LICENSE_SET_IDENTIFICATION),
        switchMap(() => {
            if (state$.value.license.onlineActivation) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED
                        },
                        method: handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.LICENSE_SET_PROCESS_STEP,
                    payload: {
                        step: 2
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED
                    },
                    method: handlers.GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED,
                    tabId: 0
                }
            ];
        })
    );

const getOnlineLicenseCounts = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.LICENSE_GET_ONLINE_COUNTS),
        switchMap(() => {
            if (state$.value.license.onlineActivation) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_ONLINE_LICENSE_COUNTS,
                            params: {
                                key: state$.value.license.companyId + "-" + state$.value.license.userId
                            }
                        },
                        method: handlers.ONLINE_LICENSE_COUNTS,
                        tabId: 0
                    }
                ];
            }
            return [];
        })
    );

const setProduct = (action$) =>
    action$.pipe(
        ofType(actionTypes.LICENSE_SET_PRODUCT),
        switchMap(() => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_REGISTRATION_DATA
                    },
                    method: handlers.GET_REGISTRATION_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.LICENSE_SET_PROCESS_STEP,
                    payload: {
                        step: 3
                    }
                }
            ];
        })
    );

const setData = (action$, state$) =>
    action$.pipe(
        ofType(actionTypes.LICENSE_SET_DATA),
        switchMap(({payload}) => {
            if (state$.value.license.onlineActivation) {
                return [
                    {
                        type: actionTypes.SERVER_REQUEST,
                        payload: {
                            type: methods.METHOD_ONLINE_LICENSE_ACTIVATE,
                            params: {
                                key: state$.value.license.companyId + "-" + state$.value.license.userId,
                                product: state$.value.license.product.id,
                                regData: payload.data,
                                modules: []
                            }
                        },
                        method: handlers.ONLINE_LICENSE_ACTIVATE,
                        tabId: 0
                    }
                ];
            }

            return [
                {
                    type: actionTypes.LICENSE_SET_PROCESS_STEP,
                    payload: {
                        step: 4
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_CREATE_LICENSE_REQUEST,
                        params: {
                            key: state$.value.license.companyId + "-" + state$.value.license.userId,
                            product: state$.value.license.product.id,
                            regData: payload.data,
                            modules: []
                        }
                    },
                    method: handlers.CREATE_LICENSE_REQUEST,
                    tabId: 0
                }
            ];
        })
    );

const getLicenseInfo = (action$) =>
    action$.pipe(
        ofType(actionTypes.SERVER_IS_LICENSED),
        switchMap(() => {
            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_REGISTRATION_DATA
                    },
                    method: handlers.GET_REGISTRATION_DATA,
                    tabId: 0
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_GET_LICENSE_INFO
                    },
                    method: handlers.GET_LICENSE_INFO,
                    tabId: 0
                }
            ];
        })
    );

const logOutAndReactivate = (action$) =>
    action$.pipe(
        ofType(actionTypes.LOG_OUT_AND_REACTIVATE),
        switchMap(() => {
            return [
                {
                    type: actionTypes.LOG_OUT_SUCCESS
                },
                {
                    type: actionTypes.SERVER_NOT_LICENSED
                }
            ];
        })
    );

export default [setIdentification, getOnlineLicenseCounts, setProduct, setData, getLicenseInfo, logOutAndReactivate];
